import styled from 'styled-components'

export const Container = styled.div``


export const BoxAreaDoTalhao = styled.div`
    position: absolute;
    top: 40px;
    left: 40px;
    z-index: 100;
    background: #fff;
    box-sizing: border-box;
    padding: 10px 15px;
    border-radius: 10px;
    box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.2);
-webkit-box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.2);
-moz-box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.2);

    p {
        margin: 0;
        padding: 0;
        font-weight: 600;
        color: var(--text-color);
    }
    span {
        margin: 0;
        padding: 0;
        font-weight: 500;
        color: var(--text-color);
    }
`;